import heroScripts from "./components/heroScripts";

window.addEventListener( "DOMContentLoaded", () => heroScripts() );
